export default __webpack_public_path__ + "7f0cadcc9081ce094690e3e026dbe5a3.woff2";